interface ConfirmationInput {
  email: string;
  password: string;
  confirmationCode: string;
}

interface SignupPorts {
  confirm: (input: { username: string; confirmationCode: string }) => Promise<unknown>;
  signIn: (input: { username: string; password: string }) => Promise<{ isSignedIn: boolean }>;
}

export const completeConfirmedSignup = async (
  ports: SignupPorts,
  input: ConfirmationInput,
): Promise<"signed_in" | "verified"> => {
  await ports.confirm({ username: input.email, confirmationCode: input.confirmationCode });
  try {
    const result = await ports.signIn({ username: input.email, password: input.password });
    return result.isSignedIn ? "signed_in" : "verified";
  } catch {
    return "verified";
  }
};
